import { CustomSelectFieldProps, SelectField } from 'components/form'
import { CategoriaArquivoAtendProfEnum } from 'graphql/types.generated'

import { categoriaAnexoLabelRecord, CategoriaArquivoSelectModel } from '../model-anexoArquivos'

type CategoriaArquivoSelectFieldProps = CustomSelectFieldProps<CategoriaArquivoSelectModel>

export function CategoriaArquivoSelectField(props: CategoriaArquivoSelectFieldProps) {
  return <SelectField<CategoriaArquivoSelectModel> itemToString={itemToString} items={items} {...props} />
}

const items = Object.values(CategoriaArquivoAtendProfEnum)
const itemToString = (item: CategoriaArquivoSelectModel) => item && categoriaAnexoLabelRecord[item]
